import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['leap', 'pragmatic', 'relax', 'blueprint'],
        'live-casino': ['pragmatic', 'ezugi'],
        virtuals: ['leap', 'pragmatic'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: false,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino', 'bingo'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'],
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: false,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: true,
    depositRestriction: true,
    deceased: false,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text:
            'This site is operated by SharedBet Ltd (14880373) (licence number {{licenceNumber}}) is licensed and regulated by the Gambling Commision. 25 Wilton Road, Pimlico, London. SW1V 1LG.',
        licence_number: '63635',
        licence_url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/63635',
        cookies_url: 'https://nrg.bet/?account=static&static=cookie-policy',
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: 'GTM-KXRPQ9DF',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'NRG',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    reportsV2: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '1',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'kaching',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'NRG Events',
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: false,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: false,

    /* U */
    useExtraPlacesForEvents: false,
    usePaymentFormForUniverse: {
        type: 'paysafe',
        apiKey: 'T1QtNDM5NTU0OkItcDEtMC02NjQyMGMzNi0wLTMwMmMwMjE0N2I4MDlhMjJkMDU2NmExMGYwMmZmZTM5MjlmMTg3NmE5MTZhMzE3YzAyMTQxMzYxNTZlNzUwYmUwZDRlZDUxYzE5MGZlMTk0ZTBkM2MyMTI2YTVl',
        environment: 'LIVE',
        cardAccounts: { GBP: '1003298014', EUR: '' },
        openBanking: 'yaspa',
    },
    userTitleOptional: false,
    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        BackofficeReports: 'BackOfficeReports-NRG/DB-Casino',
        CasinoDashboard: 'CasinoDashboard-NRG/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-NRG/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-NRG/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-NRG/DailyKPI',
        RacecourseDashboard: 'Racecourse-NRG/RacecourseMediaGroupDashboard',
        TransactionsDashboard: 'TransactionsDashboard-NRG/TransactionsMainDashboard',
        AccountBalances: 'AccountBalances-NRG/AccountBalances',
        Accounts: 'Accounts-NRG/Overview',
        SRGDashboard: 'SRGDashboard-NRG/DBAverageStakes',
        CampaignsDashboard: 'CampaignsDashboard-NRG/CampaignUserDashboard',
        SymplifyStats: 'SymplifyStats-NRG/CampaignUserDashboard',
        RollingNetDeposits: 'RollingNetDeposits-NRG/RollingNetDeposits',
        BonusEngine: 'BonusEngine-NRG/CampaignLevel',
        DepositRestrictions: 'Compliance-NRG/DepositRestrictions',
        RetentionDashboard: 'RetentionDashboard-NRG/Retention',
        PlatformOverview: 'Overview-NRG/Overview',
    },
};
